module.exports = __webpack_public_path__ + "img/meta.bd34adc5.svg";